import { useState } from "react";
import { toast } from "sonner";
import { Modal } from "./Modal";

const INPUT_CLS = "mt-1.5 w-full px-3.5 py-2.5 rounded-lg border text-sm text-slate-900 focus:outline-none focus:ring-4 focus:ring-amber-500/10 focus:border-amber-400 transition-all";
const INPUT_STYLE = { borderColor: "var(--hx-border)" };

function defaultBlockedUntil() {
  const date = new Date(Date.now() + 60 * 60 * 1000);
  date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
  return date.toISOString().slice(0, 16);
}

export function BlockHoardingModal({ onClose, onSave }) {
  const [form, setForm] = useState({ blocked_until: defaultBlockedUntil(), reason: "" });
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    const reason = form.reason.trim();
    if (!form.blocked_until) { toast.error("Blocked until is required"); return; }
    if (!reason) { toast.error("Reason is required"); return; }
    if (reason.length > 200) { toast.error("Reason must be 200 characters or less"); return; }
    const blockedUntil = new Date(form.blocked_until);
    if (Number.isNaN(blockedUntil.getTime()) || blockedUntil <= new Date()) {
      toast.error("Blocked until must be in the future");
      return;
    }

    setLoading(true);
    try {
      await onSave({ blocked_until: blockedUntil.toISOString(), reason });
      onClose();
    } catch {
      // handled upstream
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal title="Block Hoarding" onClose={onClose} accent="amber">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="text-xs font-semibold uppercase tracking-wide text-slate-500">Blocked Until</label>
          <input
            type="datetime-local"
            value={form.blocked_until}
            min={new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 16)}
            onChange={(e) => setForm((f) => ({ ...f, blocked_until: e.target.value }))}
            required
            className={INPUT_CLS}
            style={INPUT_STYLE}
          />
        </div>

        <div>
          <div className="flex items-center justify-between gap-3">
            <label className="text-xs font-semibold uppercase tracking-wide text-slate-500">Reason</label>
            <span className="text-xs font-medium text-slate-400">{form.reason.length}/200</span>
          </div>
          <textarea
            value={form.reason}
            maxLength={200}
            onChange={(e) => setForm((f) => ({ ...f, reason: e.target.value }))}
            rows={3}
            required
            placeholder="Reason for blocking this hoarding"
            className={`${INPUT_CLS} resize-none`}
            style={INPUT_STYLE}
          />
        </div>

        <div className="flex gap-2 pt-1">
          <button type="button" onClick={onClose} className="hx-secondary-action flex-1">Cancel</button>
          <button type="submit" disabled={loading} className="hx-primary-action flex-1">
            {loading ? "Blocking..." : "Block"}
          </button>
        </div>
      </form>
    </Modal>
  );
}
